<form [formGroup]="debtorForm" *ngIf="!fourEyes">
  <div class="card card-accent-primary shadowed">
    <div class="card-header">
      <strong>{{visuals.selectDbt}}</strong>
    </div>
    <div class="card-block">
      <div class="form-group">
        <div class="col-md-12 input-group">
          <input
            type="number"
            [formControl]="debtorForm.controls['debtorId']"
            (change)="isDebtorChecked=false"
            class="form-control"
            id="debtorId"
            name="debtorId"
          />
          <basesearchmodal
            [type]="'debtorModal'"
            (valueChange)="valueChanged('debtorModal',$event)"
          ></basesearchmodal>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <button type="button" class="btn btn-danger" data-dismiss="modal" (click)="clearDebtorList()">
        {{visuals.clear}}
      </button>
      <button type="submit" class="btn btn-success" data-dismiss="modal" (click)="searchClusters()">
        {{visuals.search}}
      </button>
    </div>
  </div>
</form>
<div *ngIf="loading" class="dataLoader"></div>

<ul class="list-group" *ngIf="!loading">
  <li
    style="margin-bottom: 5px;"
    class="list-group-item"
    *ngFor="let cluster of clusters;let i=index"
  >
    {{ cluster.description }}
    <i
      *ngIf="!viewRole"
      (click)="updateCluster(cluster.id)"
      style="position: absolute;right: 15px;"
      class="mdi md-16 mdi-pencil mb-12 text-info"
    ></i>
    <i
      *ngIf="!viewRole"
      (click)="openDeleteModal(cluster.id);"
      data-id="{{ cluster.id }}"
      style="position: absolute;right: 50px;"
      class="mdi md-16 mdi-trash-can-outline text-danger"
    ></i>
  </li>
</ul>
<div *ngIf="!loading && !viewRole && !fourEyes" class="text-right" >
  <i class="mdi md-64 mdi-plus-circle text-primary" (click)="openNewModal();"></i>
</div>
<div
  bsModal
  #confirmDeleteModal="bs-modal"
  [config]="{backdrop: 'static'}"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left"></h4>
        <button
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="confirmDeleteModal.hide()"
        >
          <span aria-hidden="true"><i class="fa fa-close"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <h4 style="text-align: center;">{{visuals.confDelCluster}}</h4>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          (click)="confirmDeleteModal.hide()"
        >
          {{visuals.cancel}}
        </button>
        <button
          type="button"
          class="btn btn-success"
          data-dismiss="modal"
          (click)="checkCluster(modalClusterId);actionStatus = 'delete';"
        >
          {{visuals.submit}}
        </button>
      </div>
    </div>
  </div>
</div>

<div
  bsModal
  #confirmModal="bs-modal"
  [config]="{backdrop: 'static'}"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
  *ngIf="!fourEyes"
>
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div>
        <div *ngIf="!fourEyes" class="modal-header">
          <h4 class="modal-title pull-left"></h4>
          <button
            type="button"
            class="close pull-right"
            aria-label="Close"
            (click)="confirmModal.hide();"
          >
            <span aria-hidden="true"><i class="fa fa-close"></i></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="card card-accent-primary shadowed" *ngIf="!loadingForm">
            <div class="card-header">
              <strong>
                <div *ngIf="isEditing; else elseBlock">{{visuals.updateTitle}}</div>
                <ng-template #elseBlock>{{visuals.title}}</ng-template>
              </strong>
            </div>
            <div class="card-block">
              @if (form) {
                <form [formGroup]="form" (ngSubmit)="onSubmit()">
                  <ng-container *ngFor="let step of fields; let index = index;">
                    <formly-form
                      [form]="form.at(index)"
                      [(model)]="model"
                      [fields]="step.fields"
                      [options]="options"
                    >
                    </formly-form>
                  </ng-container>
                  <div class="text-center m-2" *ngIf="!clusterCannotBeAltered">
                    <button class="btn btn-secondary" type="submit">
                      {{visuals.submit}}
                    </button>
                  </div>
                </form>
              }
            </div>
          </div>
          <div *ngIf="loadingForm" class="dataLoader"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="fourEyes">
  <!-- {{form?.value | json}} -->
  <ng-container *ngFor="let step of fields; let index = index;">
    <formly-form [form]="form.at(index)" [model]="model" [fields]="step.fields" [options]="options">
    </formly-form>
  </ng-container>
</form>
<div class="card"  *ngIf="!loading && !fourEyes" >
  <div class="card-header">
    <strong>{{genericVisuals?.requestForApprovalGridTitle}}</strong>
    <a
        href="javascript:void(0);"
        role="button"
        class="pull-right"
        (click)="isCollapsed = !isCollapsed"
      >
        @if (isCollapsed) {
          <i class="fa fa-plus-circle"></i>
        } @else {
          <i class="fa fa-minus-circle"></i>
        }
      </a>
  </div>
  <div class="card-block p-0" [collapse]="isCollapsed">
    <requestsForApproval [selectorName]="tagName"></requestsForApproval>
  </div>
</div>